import { useCallback, VFC } from 'react';
import { Modal } from 'antd';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../../components/Button/Button';
import { useInstallMeterStepsStore } from '../../components/store';
import { useStore } from '../../useStore';
import { SensorLoraState } from './slice';
import { SensorConnectionStepFooter as messages } from './messages';

const { confirm } = Modal;

export const SensorConnectionStepFooter: VFC = () => {
  const { setNextStep, setPreviousStep } = useInstallMeterStepsStore();
  const { sensorLoraState } = useStore();

  const handleNextStep = useCallback(() => {
    if (sensorLoraState === SensorLoraState.NotRegistered) {
      confirm({
        title: <FormattedMessage {...messages.missingSensor} />,
        content: <FormattedMessage {...messages.sensorNotRegistered} />,
        cancelText: <FormattedMessage {...messages.cancel} />,
        okText: <FormattedMessage {...messages.continue} />,
        onOk() {
          setNextStep();
        },
        onCancel() {},
      });
    } else {
      setNextStep();
    }
  }, [sensorLoraState, setNextStep]);

  return (
    <>
      <Button block style={{ marginRight: 15 }} onClick={() => setPreviousStep()}>
        <FormattedMessage {...messages.back} />
      </Button>
      {sensorLoraState !== SensorLoraState.NotInDatabase && (
        <Button block type="primary" onClick={handleNextStep}>
          <FormattedMessage {...messages.continue} />
        </Button>
      )}
    </>
  );
};
